import { render } from "./SetGainLossesDiscountsModal.vue?vue&type=template&id=44a8dc21&scoped=true"
import script from "./SetGainLossesDiscountsModal.vue?vue&type=script&lang=js"
export * from "./SetGainLossesDiscountsModal.vue?vue&type=script&lang=js"

import "./SetGainLossesDiscountsModal.vue?vue&type=style&index=0&id=44a8dc21&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a8dc21"]])

export default __exports__